import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import productStore from "../../stores/ProductStore";
import ProductService from "../../Services/ProductService";
import PhotoBook1 from "../../assets/img/PhotoBook-5x5.jpg";
import productSizeStore from "../../stores/ProductSizeStore";
import Header from "../../Components/Header";
import CartService from "../../Services/CartService";
import loadingSpinner from '../../assets/img/Spinner.svg';


const headerLinks = [{ name: "Home", href: "/" }];
// Define Product interface
interface Product {
  productID: number;
  productName: string;
  description: string;
  basePrice: number;
  productTypeId: number;
  imageUrl: string;
  width: number;
  height: number;
  productType: string;
}

function PhotoBookFlow() {
  const [activeSection, setActiveSection] = useState(1);
  const [showButton, setShowButton] = useState(false);
  const [showBorder, setShowBorder] = useState(0);
  const [productOptions, setProductOptions] = useState<Product[]>([]);
  const [cartItemCount, setCartItemCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [projectType, setProjectType] =  useState(1);
  const navigate = useNavigate();

  const showSection = (sectionNumber: number) => {
    setActiveSection(sectionNumber);
    setShowButton(false);
    setShowBorder(0);
  };
  const fetchCartCount = async () => {
    try {
      const { CartCount } = await CartService.GetCartCount();
      setCartItemCount(CartCount);
    } catch (error) {
      console.error("Error fetching cart count:", error);
    }
  };

  useEffect(() => {
    fetchCartCount(); 
  }, []);
  useEffect(() => {
    const fetchProductSizes = async () => {
      const productTypeId = productStore.getSelectedProductId;
      try {
        if (productTypeId != null) {
          const response = await ProductService.getProductList(projectType);
          setLoading(true);
          const productList = response.map((item: any) => ({
            productID: item.productID,
            productName: item.productName,
            description: item.description,
            basePrice: item.basePrice,
            productTypeId: item.productTypeId,
            imageUrl: item.imageUrl,
            width: item.width,
            height: item.height,
            productType:"photobook"
          }));
          setProductOptions(productList);
        }
      } catch (error) {
        console.error("Error fetching product sizes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProductSizes();
  }, []);

  const personalizeClick = (product: Product) => {
    productSizeStore.setSelectedProduct({
      prdWidth: product.width,
      prdHeight: product.height,
      productId: product.productID,
      basePrice: product.basePrice,
      description: product.description,
      productName: product.productName,
      productTypeId:product.productTypeId,
      productType: product.productType
    });

    navigate(process.env.REACT_APP_PublicPath + "/setproductname", { replace: true });
  };

  return (
    <><Header cartItemsCount={cartItemCount}  title="My Website" links={headerLinks} /><section className="ProductType">
      <div className="mx-auto max-w-7xl mt-10 mb-40 px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-normal text-left">
          Select a Product Size
        </h1>
        {loading ? (
                                            <div className="text-center my-8">
                                                <img src={loadingSpinner} alt="Loading..." className="mx-auto h-16 w-16" />
                                            </div>
                                        ) : (
<div className="grid grid-cols-3 gap-8 mt-10">
          {productOptions.length > 0 ? (
            productOptions.map((product, index) => (
              <div key={product.productID} className="border-gray-200 border shadow-md rounded-lg">

                <img
                  src={PhotoBook1}
                  alt={product.productName}
                  className="h-50 w-full rounded-t-lg p-4" />

                <div className="px-5 pb-5">
                  <h3 className="mb-1 text-lg font-medium text-gray-900">
                    {product.productName}
                  </h3>
                  <span className="text-gray-600 mr-3 uppercase text-xs">
                    {product.description}
                  </span>

                  <div className="flex items-center mt-2.5 mb-2"></div>
                  <div className="flex items-center justify-between">
                    <span className="text-lg font-semibold text-black cursor-auto my-3">
                      ${product.basePrice.toFixed(2)}
                    </span>
                    <button
                      className="text-white bg-green font-medium rounded text-sm px-5 py-2.5 text-center"
                      onClick={() => personalizeClick(product)}
                    >
                      Personalize
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>Loading products...</p>
          )}
        </div>
                                        )}
        
      </div>
    </section></>
  );
}

export default PhotoBookFlow;
